export const iconFontAwesomeToggleMicrophoneSlash = (
	<i className="fa-solid fa-microphone-slash"></i>
);
